const envConfig = {
    isDev: false,
};

module.exports = envConfig;